import { MediaPlaylist } from 'hls.js';

import { MediaElementActionPayload, MediaElementState } from '../types';

export enum MediaStateActions {
  UPDATE_AUDIO_TRACK_INDEX = 'updateAudioTrackIndex',
  UPDATE_AUDIO_TRACKS = 'updateAudioTracks',
  UPDATE_CAN_PLAY = 'updateCanPlay',
  UPDATE_CURRENT_TIME = 'updateCurrentTime',
  UPDATE_DURATION = 'updateDuration',
  UPDATE_IS_MUTED = 'updateIsMuted',
  UPDATE_IS_PAUSED = 'updateIsPaused',
  UPDATE_MEDIA_ELEMENT_STATE = 'updateMediaElementState',
  UPDATE_SEEKING = 'updateSeeking',
  UPDATE_SELECTED_SUBTITLE = 'updateSelectedSubtitle',
  UPDATE_SUBTITLES_ENABLED = 'upupdateSubtitlesEnabled',
  UPDATE_TEXT_TRACKS = 'updateTextTracks',
  UPDATE_VOLUME = 'updateVolume',
}

export const updateState = (mediaState: MediaElementState): MediaElementActionPayload => ({
  payload: mediaState,
  type: MediaStateActions.UPDATE_MEDIA_ELEMENT_STATE,
});

export const updateCanPlay = (canPlay: boolean): MediaElementActionPayload => ({
  payload: canPlay,
  type: MediaStateActions.UPDATE_CAN_PLAY,
});

export const updateIsPaused = (isPaused: boolean): MediaElementActionPayload => ({
  payload: isPaused,
  type: MediaStateActions.UPDATE_IS_PAUSED,
});

export const updateVolume = (volume: number): MediaElementActionPayload => ({
  payload: volume,
  type: MediaStateActions.UPDATE_VOLUME,
});

export const updateIsMuted = (isMuted: boolean): MediaElementActionPayload => ({
  payload: isMuted,
  type: MediaStateActions.UPDATE_IS_MUTED,
});

export const updateDuration = (duration: number): MediaElementActionPayload => ({
  payload: duration,
  type: MediaStateActions.UPDATE_DURATION,
});

export const updateCurrentTime = (currentTime: number): MediaElementActionPayload => ({
  payload: currentTime,
  type: MediaStateActions.UPDATE_CURRENT_TIME,
});

export const updateSeeking = (seeking: boolean): MediaElementActionPayload => ({
  payload: seeking,
  type: MediaStateActions.UPDATE_SEEKING,
});

export const updateTextTracks = (textTracks: TextTrackList): MediaElementActionPayload => ({
  payload: textTracks,
  type: MediaStateActions.UPDATE_TEXT_TRACKS,
});

export const updateSubtitleEnabled = (subtitleEnabled: boolean): MediaElementActionPayload => ({
  payload: subtitleEnabled,
  type: MediaStateActions.UPDATE_SUBTITLES_ENABLED,
});

export const updateSelectedSubtitle = (subtitle: TextTrack | null): MediaElementActionPayload => ({
  payload: subtitle,
  type: MediaStateActions.UPDATE_SELECTED_SUBTITLE,
});

export const updateAudioTracks = (audioTracks: MediaPlaylist[]): MediaElementActionPayload => ({
  payload: audioTracks,
  type: MediaStateActions.UPDATE_AUDIO_TRACKS,
});

export const updateAudioTrackIndex = (trackIndex: number): MediaElementActionPayload => ({
  payload: trackIndex,
  type: MediaStateActions.UPDATE_AUDIO_TRACK_INDEX,
});
